import { render, staticRenderFns } from "./NcrUserDetail.vue?vue&type=template&id=0113d736&"
import script from "./NcrUserDetail.vue?vue&type=script&lang=js&"
export * from "./NcrUserDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports